<script setup>
import { trackEvent } from '@/composables/useAnalytics.js'

defineProps({
  modelValue: { type: String, default: 'featured' },
  inputId:    { type: String, default: 'resource-sort' },
})

const emit = defineEmits(['update:sort'])

const OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'date',     label: 'Published date' },
]

function onChange(event) {
  const value = event.target.value
  trackEvent('sort_resources', { sort_value: value })
  emit('update:sort', value)
}
</script>

<template>
  <div class="sort">
    <label class="label" :for="inputId">Sort by</label>
    <div class="select-wrap">
      <select
        :id="inputId"
        class="select"
        :value="modelValue"
        @change="onChange"
      >
        <option v-for="opt in OPTIONS" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
      <svg class="chevron" viewBox="0 0 20 20" width="14" height="14" fill="none" aria-hidden="true">
        <path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sort {
  display: flex;
  align-items: center;
  gap: $space-2;

  .label {
    font-size: $font-size-sm;
    font-weight: 600;
    color: var(--color-text-muted);
    white-space: nowrap;
  }

  // Wraps the native <select> so the border/radius/focus-ring live on the
  // wrapper and a custom chevron can overlay the (appearance: none) control —
  // same integrated-bar treatment as ResourceSearch's .bar.
  .select-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--color-border);
    @include rounded($radius);
    background: var(--color-surface);
    @include transition(border-color, box-shadow);

    &:focus-within { @include focus-ring; }
  }

  .select {
    appearance: none;
    -webkit-appearance: none;
    border: none;
    background: transparent;
    font-family: $font-sans;
    font-size: $font-size-sm;
    color: var(--color-ink);
    // Right padding leaves room for the overlaid chevron.
    padding: $space-2 calc(#{$space-6} + #{$space-1}) $space-2 $space-3;
    cursor: pointer;

    &:focus { outline: none; }   // ring shown on .select-wrap via :focus-within
  }

  .chevron {
    position: absolute;
    right: $space-3;
    color: var(--color-text-muted);
    pointer-events: none;
  }
}
</style>
